import { createRoot } from 'react-dom/client'
import { App } from './app'
import './index.css'
// i18n must be imported before App so language is initialised before any
// component renders. The import has side effects (i18next.init call).
import './i18n/config'

// StrictMode removed: React 19 double-mount breaks BlockNote's ProseMirror
// drag-and-drop internals (side menu event handlers register twice).
createRoot(document.getElementById('root')!).render(<App />)
